module.exports = __webpack_public_path__ + "img/2.1f8c6e8c.jpg";